<template>
  <div>
    <template-item label="标题设置">
      <el-switch
        v-model="includeProvince"
        active-text="包含省"
        inactive-text="只显示市"
      >
      </el-switch>
    </template-item>
    <template-item v-if="includeProvince" label="级联分隔符">
      <el-input v-model="separator" size="mini" placeholder="分隔符" />
    </template-item>
    <template-item layout="flex" label="生成的行/列">
      <area-cascade-multi-selector
        v-model="checkedListProxy"
        :deep="2"
        :provinces="provinces"
        :show-prefix="includeProvince"
        style="overflow: hidden;"
      />
    </template-item>
  </div>
</template>
<script>
import { Switch, Input } from "element-ui";
import AreaCascadeMultiSelector from "@/components/selector/area/CascadeMultiSelector";
import TemplateItem from "@/components/excel/designer/template/TemplateItem";

export default {
  name: "sequence-city-selector",
  components: {
    TemplateItem,
    AreaCascadeMultiSelector,
    [Switch.name]: Switch,
    [Input.name]: Input,
  },
  props: {
    provinces: {
      type: Array,
    },
    value: {
      type: Array,
    },
  },
  computed: {
    checkedListProxy: {
      get() {
        return this.checkedList;
      },
      set(value) {
        this.checkedList = value;
        this.$emit("update:value", value);
        this.$emit("change", value);
      },
    },
  },
  watch: {
    value(value) {
      this.checkedList = value || [];
    },
  },
  data() {
    return {
      includeProvince: true,
      separator: "/",
      checkedList: [],
    };
  },
  methods: {},
};
</script>
